import { useMutation } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { updateUser } from 'src/services/napi/users/updateUser';
import { useNotification } from '../../../providers/notificationsProvider';

const updateUserData = async ({ fullName, email, role, password, id, tags }) => {
  const currentProject = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);

  if (!currentProject) return;
  const { _id: projectId } = currentProject;

  const [name, surname] = fullName.split(' ');
  const data = { email: email.trim(), name, password: password.trim(), role, surname, tags };
  await updateUser(projectId, id, data);
};

export const useUpdateUser = ({ onError, onSuccess }) => {
  const { notify } = useNotification();

  return useMutation((data) => updateUserData(data), {
    onError: () => {
      notify({ message: 'something went wrong', severity: 'error' });
      if (onError) {
        onError();
      }
    },
    onSuccess: () => {
      if (onSuccess) {
        onSuccess();
      }
    }
  });
};
